import { render, staticRenderFns } from "./ItemVehicle.vue?vue&type=template&id=2f10f26c&"
import script from "./ItemVehicle.vue?vue&type=script&lang=js&"
export * from "./ItemVehicle.vue?vue&type=script&lang=js&"
import style0 from "./ItemVehicle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports